import React from 'react'
import styles from "../../styles/screens/PrasadGift/PGBenefits.module.css"
import ramDarbarBenefits from "../../assets/prasad_gift/ramDarbarBenefits.png"
import krishnaDarbarBenefits from "../../assets/prasad_gift/krishnaDarbarBenefits.png"

const PGBenefits = ({ productId }) => {
  return (
    <div className={styles.benefitsContainer}>
      <div className={styles.backgroundFlower}></div>
      <div className={styles.benefitsContent}>
        <h2 className={styles.benefitsTitle}>
          {productId === "ramdarbar" 
            ? "Benefits of Ram Darbar" 
            : "Benefits of Krishna Darbar"}
        </h2>
        <p className={styles.benefitsSubtitle}>
          {productId === "ramdarbar" 
            ? "(Blessed & Sourced directly from Ayodhya )" 
            : "(Blessed & Sourced directly from Vrindavan )"}
        </p>
        <div className={styles.benefitsUnderline}></div>

        <div className={styles.benefitsLayout}>
          <div className={styles.productImageContainer}>
            <img
              src={productId === "ramdarbar" 
                ? ramDarbarBenefits
                : krishnaDarbarBenefits}
              alt={productId === "ramdarbar" 
                ? "Ram Darbar in Orange Pouch" 
                : "Krishna Darbar in Blue Pouch"}
              className={styles.benefitsProductImage}
            />
          </div>

          <div className={styles.benefitsList}>
            {productId === "ramdarbar" ? (
              <>
                <div className={styles.benefitItem}>
                  <h3 className={styles.benefitTitle}>Seeking Blessings</h3>
                  <p className={styles.benefitDescription}>
                    Bring home the sacred blessings of Shri Ramji from Ayodhya and stay under his divine shield.
                  </p>
                </div>

                <div className={styles.benefitItem}>
                  <h3 className={styles.benefitTitle}>Growth in Wealth</h3>
                  <p className={styles.benefitDescription}>
                    Remove financial obstacles, and invite positive energy, leading to stability and wealth growth.
                  </p>
                </div>

                <div className={styles.benefitItem}>
                  <h3 className={styles.benefitTitle}>Health and Wellness</h3>
                  <p className={styles.benefitDescription}>
                    Seeking divine help for good health, speedy recovery, and overall well-being
                  </p>
                </div>
              </>
            ) : (
              <>
                <div className={styles.benefitItem}>
                  <h3 className={styles.benefitTitle}>Divine Love & Devotion</h3>
                  <p className={styles.benefitDescription}>
                  Strengthen your bond with Lord Krishna, inviting divine love, peace, and harmony into your life.
                  </p>
                </div>

                <div className={styles.benefitItem}>
                  <h3 className={styles.benefitTitle}>Spiritual Enlightenement</h3>
                  <p className={styles.benefitDescription}>
                  Enhance your spiritual journey by fostering devotion, mindfulness, and inner bliss.
                  </p>
                </div>

                <div className={styles.benefitItem}>
                  <h3 className={styles.benefitTitle}>Blessing for Prosperity</h3>
                  <p className={styles.benefitDescription}>
                  Seek Krishna Ji’s blessings for health, abundance, and overall well-being, removing obstacles from your path.
                  </p>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default PGBenefits
